import { SearchMake } from '@cinch-nx/data-search'

export enum VehicleCondition {
  New = 'new',
  Used = 'used',
}

export interface Models {
  name: string
  stock: number
}
export interface Makes {
  name: string
  stock: number
  models: Models[]
}

export interface Bucket {
  [key: string]: number
}

export interface VehiclesData {
  totalStock: number
  makes: Makes[]
  carTypes: CarTypesCount
  priceBucket: Bucket
  monthlyPriceBucket: Bucket
}

export interface CarTypesCount {
  suv: number
  electric: number
  hatchback: number
  estate: number
  saloon: number
  coupe: number
  mpv: number
  convertible: number
  roadster: number
}

export interface SearchResponse {
  searchResultsCount: number
  facets: {
    makes: SearchMake[]
    fuelType: {
      petrol: number
      diesel: number
      'petrol/electric': number
      electric: number
      'diesel/electric': number
      'bi-fuel': number
    }
    bodyType: {
      hatchback: number
      suv: number
      estate: number
      saloon: number
      coupe: number
      mpv: number
      convertible: number
      roadster: number
    }
    priceBucket: Bucket
    monthlyPriceBucket: Bucket
  }
}
